// Copyright 2025, University of Maryland, All Rights Reserved
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { adminSettingsApi, GlobalSessionSyncSettings } from '@/api/admin-settings-api'

export function useSyncSettings() {
  const queryClient = useQueryClient()

  const { data, isLoading, isError } = useQuery({
    queryKey: ['admin', 'syncSettings'],
    queryFn: adminSettingsApi.getSyncSettings,
  })

  const { mutate: updateSyncSettings, isPending } = useMutation({
    mutationFn: (settings: { 
      session_sync: GlobalSessionSyncSettings
    }) => adminSettingsApi.updateSyncSettings(settings),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'syncSettings'] })
    }
  })

  return {
    data,
    isLoading,
    isError,
    updateSyncSettings,
    isPending
  }
}
